import { render, staticRenderFns } from "./MiraDevices.vue?vue&type=template&id=60bb6458&scoped=true&"
import script from "./MiraDevices.vue?vue&type=script&lang=ts&"
export * from "./MiraDevices.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDevices.vue?vue&type=style&index=0&id=60bb6458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb6458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
